import { useState, useMemo } from 'react'
import dayjs from 'dayjs'

export const PERIOD_OPTIONS = [
    { value: 'this_month', label: 'Tháng này' },
    { value: 'last_month', label: 'Tháng trước' },
    { value: 'last_3_months', label: '3 tháng gần nhất' },
    { value: 'this_year', label: 'Năm nay' },
]

export interface PeriodDates {
    start: string
    end: string
}

export function getPeriodDates(period: string): PeriodDates {
    const now = dayjs()
    switch (period) {
        case 'this_month':
            return {
                start: now.startOf('month').format('YYYY-MM-DD'),
                end: now.endOf('month').format('YYYY-MM-DD'),
            }
        case 'last_month':
            return {
                start: now
                    .subtract(1, 'month')
                    .startOf('month')
                    .format('YYYY-MM-DD'),
                end: now
                    .subtract(1, 'month')
                    .endOf('month')
                    .format('YYYY-MM-DD'),
            }
        case 'last_3_months':
            return {
                start: now
                    .subtract(3, 'month')
                    .startOf('month')
                    .format('YYYY-MM-DD'),
                end: now.endOf('month').format('YYYY-MM-DD'),
            }
        case 'this_year':
            return {
                start: now.startOf('year').format('YYYY-MM-DD'),
                end: now.endOf('year').format('YYYY-MM-DD'),
            }
        default:
            return {
                start: now.startOf('month').format('YYYY-MM-DD'),
                end: now.endOf('month').format('YYYY-MM-DD'),
            }
    }
}

/** Returns the human-readable period label with month/year, e.g. "Tháng 4/2026" */
export function getPeriodLabel(period: string): string {
    const now = dayjs()
    switch (period) {
        case 'this_month':
            return `Tháng ${now.format('M/YYYY')}`
        case 'last_month': {
            const lm = now.subtract(1, 'month')
            return `Tháng ${lm.format('M/YYYY')}`
        }
        case 'last_3_months':
            return `3 tháng gần nhất`
        case 'this_year':
            return `Năm ${now.format('YYYY')}`
        default:
            return `Tháng ${now.format('M/YYYY')}`
    }
}

export function useDashboardPeriod() {
    const [period, setPeriod] = useState('this_month')
    const { start, end } = useMemo(() => getPeriodDates(period), [period])
    const periodLabel = useMemo(() => getPeriodLabel(period), [period])

    return { period, setPeriod, start, end, periodLabel }
}
